/* Wincdkeys redesign - behaviour */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function parseTiers(str) {
    if (!str) return [];
    return str.split(',').map(function (t) {
      var p = t.split(':');
      return { min: parseInt(p[0], 10) || 1, pct: parseFloat(p[1]) || 0 };
    }).sort(function (a, b) { return a.min - b.min; });
  }
  function tierFor(tiers, q) {
    var r = { min: 1, pct: 0 };
    tiers.forEach(function (t) { if (q >= t.min) r = t; });
    return r;
  }
  function fmt(cents, cur) {
    if (typeof window.wckFormatMoney === 'function') return window.wckFormatMoney(cents);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function priceAt(base, pct) { return Math.round(base * (100 - pct) / 100); }

  /* Product page: tier pricing, quantity, variants, gallery */
  $$('[data-wck-buy]').forEach(function (root) {
    var tiers = parseTiers(root.getAttribute('data-tiers'));
    var cur = root.getAttribute('data-currency');
    var base = parseInt(root.getAttribute('data-base'), 10) || 0;
    var qty = $('[data-wck-qty]', root);
    var unit = $('[data-wck-unit]', root);
    var total = $('[data-wck-total]', root);
    var tq = $('[data-wck-tq]', root);
    var save = $('[data-wck-save]', root);
    var sel = $('[data-wck-variant]', root);
    var sku = $('[data-wck-sku]', root);
    function update() {
      var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
      var t = tierFor(tiers, q);
      var u = priceAt(base, t.pct);
      if (unit) unit.textContent = fmt(u, cur);
      if (total) total.textContent = fmt(u * q, cur);
      if (tq) tq.textContent = q;
      if (save) { save.hidden = !t.pct; save.textContent = '\u2212' + t.pct + '% volume price'; }
      $$('[data-wck-tier]', root).forEach(function (r) {
        r.classList.toggle('is-on', parseInt(r.getAttribute('data-min'), 10) === t.min);
        var c = $('[data-wck-tierprice]', r);
        if (c) c.textContent = fmt(priceAt(base, parseFloat(r.getAttribute('data-pct')) || 0), cur);
      });
    }
    function setQ(n) { if (!qty) return; qty.value = Math.max(1, n); update(); }
    var dec = $('[data-wck-dec]', root), inc = $('[data-wck-inc]', root);
    if (dec) dec.addEventListener('click', function () { setQ((parseInt(qty.value, 10) || 1) - 1); });
    if (inc) inc.addEventListener('click', function () { setQ((parseInt(qty.value, 10) || 1) + 1); });
    $$('[data-wck-set]', root).forEach(function (b) {
      b.addEventListener('click', function () { setQ(parseInt(b.getAttribute('data-wck-set'), 10)); });
    });
    if (qty) qty.addEventListener('input', update);
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      base = parseInt(o.getAttribute('data-price'), 10) || base;
      if (sku) sku.textContent = (o.getAttribute('data-sku') ? o.getAttribute('data-sku') + ' \u00b7 ' : '') + (o.getAttribute('data-vendor') || '');
      update();
    });
    var main = $('[data-wck-main]', root);
    $$('[data-wck-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var img = main && main.querySelector('img');
        if (img) { img.src = b.getAttribute('data-wck-thumb'); img.removeAttribute('srcset'); }
        $$('[data-wck-thumb]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); });
      });
    });
    update();
  });

  /* Tabs (product page, games) */
  $$('[data-wck-tabs]').forEach(function (box) {
    var tabs = $$('[data-wck-tab]', box);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-wck-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        $$('[data-wck-panel]', box).forEach(function (p) { p.hidden = p.getAttribute('data-wck-panel') !== id; });
      });
    });
  });

  /* Product recommendations */
  $$('[data-wck-reco]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div');
      d.innerHTML = html;
      var fresh = d.querySelector('[data-wck-reco]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* Wholesale quick order */
  var qo = $('[data-wck-qo]');
  if (qo) {
    var tiers = parseTiers(qo.getAttribute('data-tiers'));
    var cur = qo.getAttribute('data-currency');
    var rows = $$('[data-wck-row]', qo);
    var msg = $('[data-wck-msg]', qo);
    function q(r) { return Math.max(0, parseInt($('input', r).value, 10) || 0); }
    function say(t, bad) { if (!msg) return; msg.textContent = t; msg.className = bad ? 'wck-err' : 'wck-note'; }
    function update() {
      var keys = 0, list = 0, sub = 0;
      rows.forEach(function (r) { keys += q(r); });
      var t = tierFor(tiers, Math.max(keys, 1));
      rows.forEach(function (r) {
        var n = q(r), p = parseInt(r.getAttribute('data-price'), 10) || 0, u = priceAt(p, t.pct);
        list += p * n; sub += u * n;
        $('[data-wck-your]', r).textContent = fmt(u, cur);
        $('[data-wck-line]', r).textContent = fmt(u * n, cur);
        r.classList.toggle('has-qty', n > 0);
      });
      $('[data-wck-keys]', qo).textContent = keys;
      $('[data-wck-list]', qo).textContent = fmt(list, cur);
      $('[data-wck-saved]', qo).textContent = '\u2212' + fmt(list - sub, cur);
      $('[data-wck-sub]', qo).textContent = fmt(sub, cur);
      var lab = $('[data-wck-tierlabel]', qo);
      if (lab) lab.textContent = t.pct ? ('\u2212' + t.pct + '% on every line') : 'List price';
      $$('[data-wck-tier]', qo).forEach(function (x) { x.classList.toggle('is-on', parseInt(x.getAttribute('data-min'), 10) === t.min); });
    }
    rows.forEach(function (r) {
      var inp = $('input', r);
      inp.addEventListener('input', update);
      $$('[data-step]', r).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = q(r), dir = parseInt(b.getAttribute('data-step'), 10);
          var step = n >= 50 ? 10 : (n >= 10 ? 5 : 1);
          if (dir < 0 && n <= 50 && n > 10) step = 5;
          if (dir < 0 && n <= 10) step = 1;
          inp.value = Math.max(0, n + dir * step);
          update();
        });
      });
    });
    var find = $('[data-wck-find]', qo);
    if (find) find.addEventListener('input', function () {
      var s = find.value.trim().toLowerCase();
      rows.forEach(function (r) { r.hidden = !!s && r.getAttribute('data-search').indexOf(s) === -1; });
    });
    var csv = $('[data-wck-csv]', qo);
    if (csv) csv.addEventListener('change', function () {
      var f = csv.files && csv.files[0];
      if (!f) return;
      var rd = new FileReader();
      rd.onload = function () {
        var hit = 0, miss = [];
        String(rd.result).split(/\r?\n/).forEach(function (line) {
          var c = line.split(/[,;\t]/).map(function (x) { return x.replace(/"/g, '').trim(); });
          if (c.length < 2 || !c[0]) return;
          var n = parseInt(c[1], 10);
          if (isNaN(n)) return;
          var row = rows.filter(function (r) { return (r.getAttribute('data-sku') || '').toLowerCase() === c[0].toLowerCase(); })[0];
          if (row) { $('input', row).value = n; hit++; } else { miss.push(c[0]); }
        });
        update();
        say(hit + ' line(s) filled from CSV' + (miss.length ? '. Not found: ' + miss.slice(0, 8).join(', ') : '.'), miss.length > 0 && hit === 0);
        csv.value = '';
      };
      rd.readAsText(f);
    });
    var dl = $('[data-wck-dl]', qo);
    if (dl) dl.addEventListener('click', function () {
      var top = tiers.length ? tiers[tiers.length - 1] : { pct: 0 };
      var out = ['SKU,Product,List price,Top tier price'];
      rows.forEach(function (r) {
        var p = parseInt(r.getAttribute('data-price'), 10) || 0;
        out.push([r.getAttribute('data-sku'), '"' + r.getAttribute('data-title').replace(/"/g, "'") + '"', (p / 100).toFixed(2), (priceAt(p, top.pct) / 100).toFixed(2)].join(','));
      });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([out.join('\n')], { type: 'text/csv' }));
      a.download = 'wincdkeys-price-list.csv';
      document.body.appendChild(a); a.click(); a.remove();
    });
    function items() {
      return rows.filter(function (r) { return q(r) > 0; }).map(function (r) { return { id: parseInt(r.getAttribute('data-id'), 10), quantity: q(r) }; });
    }
    $$('[data-wck-add]', qo).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = items();
        if (!list.length) { say('Add a quantity to at least one product first.', true); return; }
        btn.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: list })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
            window.location.href = btn.getAttribute('data-wck-add');
          }).catch(function (e) { say(e.message, true); btn.disabled = false; });
      });
    });
    var quote = $('[data-wck-quote]', qo);
    if (quote) quote.addEventListener('click', function () {
      var lines = rows.filter(function (r) { return q(r) > 0; }).map(function (r) { return q(r) + ' x ' + r.getAttribute('data-sku') + ' - ' + r.getAttribute('data-title'); });
      if (!lines.length) { say('Add a quantity to at least one product first.', true); return; }
      window.location.href = 'mailto:' + quote.getAttribute('data-wck-quote') + '?subject=' + encodeURIComponent('Wholesale quote request') + '&body=' + encodeURIComponent('Please quote the following:\n\n' + lines.join('\n'));
    });
    update();
  }
})();
